// extracted by mini-css-extract-plugin
export default {"bounce":"AreaPin_bounce__rDHOJ"};